import { HotelRoomApiModel } from '@era/inroom-sdk';

import { EntityAdapter, EntityState, Update, createEntityAdapter } from '@ngrx/entity';

import { RoomActionTypes, RoomActionsUnion } from './rooms.actions';

export const inRoomRoomsFeatureKey = 'inroom-rooms';

export type RoomState = EntityState<HotelRoomApiModel>;

export function selectRoomId(room: HotelRoomApiModel): string {
  return `${room.HotelCode ?? ''}-${room.Room ?? ''}`; // Can't set HotelCode and Room to required, because it is a model from IReckon.
}

export const adapter: EntityAdapter<HotelRoomApiModel> = createEntityAdapter<HotelRoomApiModel>({
  selectId: selectRoomId,
});

export const initialstate: RoomState = adapter.getInitialState({});

export function roomsReducer(state: RoomState = initialstate, action: RoomActionsUnion): RoomState {
  switch (action.type) {
    case RoomActionTypes.ROOM_API_ROOM_ADDED:
      return adapter.addOne(action.payload, state);
    case RoomActionTypes.ROOM_API_ROOMS_LOADED:
      return adapter.setAll(action.payload, state);
    case RoomActionTypes.ROOM_API_ROOM_DELETED:
      return adapter.removeOne(selectRoomId(action.payload), state);
    case RoomActionTypes.ROOM_HEADER_ROOM_DELETED:
      return {
        ...state,
      };
    case RoomActionTypes.ROOM_API_ROOM_LOADED:
    case RoomActionTypes.ROOM_SIGNALR_STATE_CHANGE:
      return adapter.updateOne(action.payload, state);
    case RoomActionTypes.ROOM_EXTRA_DATA_UPDATED_API: {
      const update: Update<HotelRoomApiModel> = {
        id: `${action.payload.hotelCode}-${action.payload.unitCode}`,
        changes: {
          ExtraData: action.payload.data,
        },
      };

      return adapter.updateOne(update, state);
    }
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectRoomIds = selectIds;

export const selectRoomEntities = selectEntities;

export const selectAllRooms = selectAll;

export const selectRoomTotal = selectTotal;
